import { render, staticRenderFns } from "./SummarySkeleton.vue?vue&type=template&id=afbc4db8&scoped=true"
import script from "./SummarySkeleton.vue?vue&type=script&lang=js"
export * from "./SummarySkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbc4db8",
  null
  
)

export default component.exports